import { SpaEntityType } from 'shared-types/Spa';
import { SpaPackageListingType } from 'shared-types/SpaPackage';

export const mapSpaEntitiesWithPrice = (
  staticEntities: (SpaEntityType | SpaPackageListingType)[],
  entitiesWithPrice: (SpaEntityType | SpaPackageListingType)[]
): (SpaEntityType | SpaPackageListingType)[] => {
  const entitiesWithPriceMap = new Map(entitiesWithPrice.map((item) => [item.id, item]));
  return staticEntities.map((entity) => {
    const entityWithPrice = entitiesWithPriceMap.get(entity.id);
    return {
      ...entity,
      price: entityWithPrice?.price ?? entity.price,
      discount: entityWithPrice?.discount ?? entity.discount,
    };
  });
};
